import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { NotificationsStack } from 'pvs-design-system';
import { store } from '@/store';
import ThemeProvider from '@/theme/ThemeProvider';
import { NOTIFICATIONS } from './consts';
import router from './router';
import RouterLoadingFallback from './RouterLoadingFallback';
import './app.css';
const App = () => (_jsx(Provider, { store: store, children: _jsxs(ThemeProvider, { children: [_jsx(NotificationsStack, { maxDisplayed: NOTIFICATIONS.maxDisplayed, autoHideDuration: NOTIFICATIONS.delayMs }), _jsx(Suspense, { fallback: _jsx(RouterLoadingFallback, {}), children: _jsx(RouterProvider, { router: router }) })] }) }));
export default App;
